import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloMailTemplate,cleanAloMailTemplate } from '@/models/alo/AloMailTemplate'

export default {
  getAllMailTemplate(): AxiosPromise<AlrContainer<Array<AloMailTemplate>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/MailTemplate`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloMailTemplate>>
      }]
    })
  },
  getMailTemplate(id:number):AxiosPromise<AlrContainer<AloMailTemplate>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/MailTemplate/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloMailTemplate>
      }]
    })
  },
  saveMailTemplate(mailTemplate:AloMailTemplate):AxiosPromise<AlrContainer<AloMailTemplate>> {
    cleanAloMailTemplate(mailTemplate)
    if(mailTemplate.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/MailTemplate/${mailTemplate.id}`, 
        method: 'PUT',
        data: mailTemplate,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloMailTemplate>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/MailTemplate`, 
        method: 'POST',
        data: mailTemplate,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloMailTemplate>
        }]
      })    
    }
  },
  deleteMailTemplate(id:number):AxiosPromise<AlrContainer<AloMailTemplate>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/MailTemplate/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloMailTemplate>
      }]
    })
  }
}